import Vue from "vue";
import Router from "vue-router";

import Error from "./views/Error.vue";

import Menu from "./views/Menu.vue";
import Menu2 from "./views2/Menu.vue";
import Cart from "./views/Cart.vue";
import Cart2 from "./views2/Cart.vue";
import Order from "./views/Order.vue";

import ShareNavbar from "./layout/ShareNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/:id/:cid?/:subid?",
      name: "menu",
      components: {
        default: Menu,
        header: ShareNavbar,
        footer: MainFooter,
      },
      props: {
        header: (route) => {
          return {
            id: route.params.id,
            colorOnScroll: 100,
            navbarTransparent: true,
          };
        },
        default: true,
      },
    },
    {
      path: "/cart/:id",
      name: "cart",
      components: {
        default: Cart,
        header: ShareNavbar,
        footer: MainFooter,
      },
      props: {
        header: (route) => {
          return {
            id: route.params.id,
            colorOnScroll: 100,
            navbarTransparent: true,
          };
        },
        default: true,
      },
    },
    {
      path: "/order/:id",
      name: "order",
      components: {
        default: Order,
        header: ShareNavbar,
        footer: MainFooter,
      },
      props: {
        header: (route) => {
          return {
            id: route.params.id,
            colorOnScroll: 100,
            navbarTransparent: true,
          };
        },
        default: true,
      },
    },


    {
      path: "/m2/:id/:cid?/:subid?",
      name: "menu",
      components: {
        default: Menu2,
        header: ShareNavbar,
        footer: MainFooter,
      },
      props: {
        header: (route) => {
          return {
            id: route.params.id,
            colorOnScroll: 100,
            navbarTransparent: true,
          };
        },
        default: true,
      },
    },
    {
      path: "/cart2/:id",
      name: "cart2",
      components: {
        default: Cart2,
        header: ShareNavbar,
        footer: MainFooter,
      },
      props: {
        header: (route) => {
          return {
            id: route.params.id,
            colorOnScroll: 100,
            navbarTransparent: true,
          };
        },
        default: true,
      },
    },
    { path: "*", component: Error },
  ],
  scrollBehavior: (to, from) => {
    if (to.name === from.name) {
      if (to.hash) {
        return { selector: to.hash, behavior: 'smooth', };
      }
    } else if (to.hash) {
      return { selector: to.hash, behavior: 'smooth', };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const metaauth = to.matched.find((record) => record.meta.requiresAuth);
  if (to.path === "/logout") {
    store.dispatch("logout");
    next({
      path: "/login",
    });
    return;
  }
  if (metaauth !== undefined) {
    let user = store.state.user;
    if (user === null) {
      next({
        name: "Login",
        params: { nextUrl: to.fullPath },
      });
    } else next();
  } else next();
});

export default router;
